import { ApiClient } from '@webapp/core/services/ApiClient'
import { PermissionRepository } from './PermissionRepository'

export const permissionRepository = new PermissionRepository({
  httpClient: ApiClient,
})
